import React from "react";

const RadioGroup = (props) => {
  const {
    controleId,
    comp,
    stateData: data,
    stateErrors: errors,
    isDisabled,
    handeOnChange,
  } = props;

  return (
    <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
      {comp.label && (
        <label className="form-control-label" style={{
          fontSize: "11px",
          fontWeight: 700,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: "0.7px",
          marginBottom: "8px",
          display: "block"
        }}>
          {comp.label}
        </label>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        {comp.radioValues.map((item, key) => {
          const inputId = `${controleId}${key}`;
          return (
            <div key={key} style={{ display: "flex", alignItems: "center" }}>
              <input
                type="radio"
                className="custom-control-input"
                id={inputId}
                name={controleId}
                value={item.value}
                checked={(data[controleId] || "") === item.value}
                onChange={handeOnChange}
                disabled={isDisabled}
                style={{ cursor: "pointer", width: "16px", height: "16px", marginRight: "8px" }}
              />
              <label className="custom-control-label" htmlFor={inputId} style={{
                fontSize: "13.5px",
                fontFamily: "Inter, Roboto, sans-serif",
                color: "#1e293b",
                cursor: "pointer",
                userSelect: "none",
                marginBottom: 0
              }}>
                {item.name}
              </label>
            </div>
          );
        })}
      </div>

      {errors[controleId] && (
        <div className="alert alert-danger" style={{ marginTop: 8, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px", display: "inline-block" }}>
          {errors[controleId]}
        </div>
      )}
    </div>
  );
}

export default RadioGroup;